/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as VaultRouteImport } from './routes/vault'
import { Route as TeamRouteImport } from './routes/team'
import { Route as SuspendedRouteImport } from './routes/suspended'
import { Route as SupportRouteImport } from './routes/support'
import { Route as SubmissionDossierRouteImport } from './routes/submission-dossier'
import { Route as SimulatorsRouteImport } from './routes/simulators'
import { Route as SignupRouteImport } from './routes/signup'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as RegulatoryStrategyRouteImport } from './routes/regulatory-strategy'
import { Route as ProfileRouteImport } from './routes/profile'
import { Route as ProductAccountRouteImport } from './routes/product-account'
import { Route as PredicateFinderResultRouteImport } from './routes/predicate-finder-result'
import { Route as PredicateFinderRouteImport } from './routes/predicate-finder'
import { Route as LoginRouteImport } from './routes/login'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as FaqRouteImport } from './routes/faq'
import { Route as DashboardRouteImport } from './routes/dashboard'
import { Route as CustomerAccountRouteImport } from './routes/customer-account'
import { Route as ClinicalReportsRouteImport } from './routes/clinical-reports'
import { Route as ClinicalProtocolsRouteImport } from './routes/clinical-protocols'
import { Route as BillingRouteImport } from './routes/billing'
import { Route as AdminRouteImport } from './routes/admin'
import { Route as IndexRouteImport } from './routes/index'
import { Route as SubmissionDossierProductIdRouteImport } from './routes/submission-dossier_.$productId'
import { Route as SimulatorsRegulatoryStrategyRouteImport } from './routes/simulators_.regulatory-strategy'
import { Route as SimulatorsDossierRouteImport } from './routes/simulators_.dossier'
import { Route as SimulatorsClinicalProtocolRouteImport } from './routes/simulators_.clinical-protocol'
import { Route as RegulatoryStrategyProductIdRouteImport } from './routes/regulatory-strategy_.$productId'
import { Route as ProductAccountNewRouteImport } from './routes/product-account_.new'
import { Route as PredicateFinderProductIdRouteImport } from './routes/predicate-finder_.$productId'
import { Route as OnboardingTermsRouteImport } from './routes/onboarding_.terms'
import { Route as CustomerAccountNewRouteImport } from './routes/customer-account_.new'
import { Route as ClinicalReportsProductIdRouteImport } from './routes/clinical-reports_.$productId'
import { Route as ClinicalProtocolsProductIdRouteImport } from './routes/clinical-protocols_.$productId'
import { Route as AdminVaultUploadsRouteImport } from './routes/admin.vault-uploads'
import { Route as AdminTermsRouteImport } from './routes/admin.terms'
import { Route as AdminStrategyRunsRouteImport } from './routes/admin.strategy-runs'
import { Route as AdminSettingsRouteImport } from './routes/admin.settings'
import { Route as AdminPredicateRunsRouteImport } from './routes/admin.predicate-runs'
import { Route as AdminMcpHealthRouteImport } from './routes/admin.mcp-health'
import { Route as AdminLoginRouteImport } from './routes/admin.login'
import { Route as AdminExtractionRunsRouteImport } from './routes/admin.extraction-runs'
import { Route as AdminDossierRunsRouteImport } from './routes/admin.dossier-runs'
import { Route as AdminDashboardRouteImport } from './routes/admin.dashboard'
import { Route as AdminCompaniesRouteImport } from './routes/admin.companies'
import { Route as AdminClinicalReportRunsRouteImport } from './routes/admin.clinical-report-runs'
import { Route as AdminClinicalProtocolRunsRouteImport } from './routes/admin.clinical-protocol-runs'
import { Route as AdminArchiveImportRunsRouteImport } from './routes/admin.archive-import-runs'
import { Route as VaultFolderFolderRouteImport } from './routes/vault_.folder.$folder'
import { Route as VaultDocumentRefRouteImport } from './routes/vault_.document.$ref'
import { Route as ProductAccountProductIdReviewRouteImport } from './routes/product-account_.$productId_.review'
import { Route as ProductAccountProductIdEditRouteImport } from './routes/product-account_.$productId_.edit'
import { Route as AdminCompaniesCustomerIdRouteImport } from './routes/admin.companies_.$customerId'
import { Route as VaultDocumentRefIndexRouteImport } from './routes/vault_.document.$ref.index'
import { Route as VaultMarketSourceTypeProductIdRouteImport } from './routes/vault_.market.$sourceType.$productId'
import { Route as VaultDocumentRefReviewRouteImport } from './routes/vault_.document.$ref.review'
import { Route as VaultDocumentRefEditRouteImport } from './routes/vault_.document.$ref.edit'

const VaultRoute = VaultRouteImport.update({
  id: '/vault',
  path: '/vault',
  getParentRoute: () => rootRouteImport,
} as any)
const TeamRoute = TeamRouteImport.update({
  id: '/team',
  path: '/team',
  getParentRoute: () => rootRouteImport,
} as any)
const SuspendedRoute = SuspendedRouteImport.update({
  id: '/suspended',
  path: '/suspended',
  getParentRoute: () => rootRouteImport,
} as any)
const SupportRoute = SupportRouteImport.update({
  id: '/support',
  path: '/support',
  getParentRoute: () => rootRouteImport,
} as any)
const SubmissionDossierRoute = SubmissionDossierRouteImport.update({
  id: '/submission-dossier',
  path: '/submission-dossier',
  getParentRoute: () => rootRouteImport,
} as any)
const SimulatorsRoute = SimulatorsRouteImport.update({
  id: '/simulators',
  path: '/simulators',
  getParentRoute: () => rootRouteImport,
} as any)
const SignupRoute = SignupRouteImport.update({
  id: '/signup',
  path: '/signup',
  getParentRoute: () => rootRouteImport,
} as any)
const ResetPasswordRoute = ResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const RegulatoryStrategyRoute = RegulatoryStrategyRouteImport.update({
  id: '/regulatory-strategy',
  path: '/regulatory-strategy',
  getParentRoute: () => rootRouteImport,
} as any)
const ProfileRoute = ProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => rootRouteImport,
} as any)
const ProductAccountRoute = ProductAccountRouteImport.update({
  id: '/product-account',
  path: '/product-account',
  getParentRoute: () => rootRouteImport,
} as any)
const PredicateFinderResultRoute = PredicateFinderResultRouteImport.update({
  id: '/predicate-finder-result',
  path: '/predicate-finder-result',
  getParentRoute: () => rootRouteImport,
} as any)
const PredicateFinderRoute = PredicateFinderRouteImport.update({
  id: '/predicate-finder',
  path: '/predicate-finder',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any)
const FaqRoute = FaqRouteImport.update({
  id: '/faq',
  path: '/faq',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardRoute = DashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => rootRouteImport,
} as any)
const CustomerAccountRoute = CustomerAccountRouteImport.update({
  id: '/customer-account',
  path: '/customer-account',
  getParentRoute: () => rootRouteImport,
} as any)
const ClinicalReportsRoute = ClinicalReportsRouteImport.update({
  id: '/clinical-reports',
  path: '/clinical-reports',
  getParentRoute: () => rootRouteImport,
} as any)
const ClinicalProtocolsRoute = ClinicalProtocolsRouteImport.update({
  id: '/clinical-protocols',
  path: '/clinical-protocols',
  getParentRoute: () => rootRouteImport,
} as any)
const BillingRoute = BillingRouteImport.update({
  id: '/billing',
  path: '/billing',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminRoute = AdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const SubmissionDossierProductIdRoute =
  SubmissionDossierProductIdRouteImport.update({
    id: '/submission-dossier_/$productId',
    path: '/submission-dossier/$productId',
    getParentRoute: () => rootRouteImport,
  } as any)
const SimulatorsRegulatoryStrategyRoute =
  SimulatorsRegulatoryStrategyRouteImport.update({
    id: '/simulators_/regulatory-strategy',
    path: '/simulators/regulatory-strategy',
    getParentRoute: () => rootRouteImport,
  } as any)
const SimulatorsDossierRoute = SimulatorsDossierRouteImport.update({
  id: '/simulators_/dossier',
  path: '/simulators/dossier',
  getParentRoute: () => rootRouteImport,
} as any)
const SimulatorsClinicalProtocolRoute =
  SimulatorsClinicalProtocolRouteImport.update({
    id: '/simulators_/clinical-protocol',
    path: '/simulators/clinical-protocol',
    getParentRoute: () => rootRouteImport,
  } as any)
const RegulatoryStrategyProductIdRoute =
  RegulatoryStrategyProductIdRouteImport.update({
    id: '/regulatory-strategy_/$productId',
    path: '/regulatory-strategy/$productId',
    getParentRoute: () => rootRouteImport,
  } as any)
const ProductAccountNewRoute = ProductAccountNewRouteImport.update({
  id: '/product-account_/new',
  path: '/product-account/new',
  getParentRoute: () => rootRouteImport,
} as any)
const PredicateFinderProductIdRoute =
  PredicateFinderProductIdRouteImport.update({
    id: '/predicate-finder_/$productId',
    path: '/predicate-finder/$productId',
    getParentRoute: () => rootRouteImport,
  } as any)
const OnboardingTermsRoute = OnboardingTermsRouteImport.update({
  id: '/onboarding_/terms',
  path: '/onboarding/terms',
  getParentRoute: () => rootRouteImport,
} as any)
const CustomerAccountNewRoute = CustomerAccountNewRouteImport.update({
  id: '/customer-account_/new',
  path: '/customer-account/new',
  getParentRoute: () => rootRouteImport,
} as any)
const ClinicalReportsProductIdRoute =
  ClinicalReportsProductIdRouteImport.update({
    id: '/clinical-reports_/$productId',
    path: '/clinical-reports/$productId',
    getParentRoute: () => rootRouteImport,
  } as any)
const ClinicalProtocolsProductIdRoute =
  ClinicalProtocolsProductIdRouteImport.update({
    id: '/clinical-protocols_/$productId',
    path: '/clinical-protocols/$productId',
    getParentRoute: () => rootRouteImport,
  } as any)
const AdminVaultUploadsRoute = AdminVaultUploadsRouteImport.update({
  id: '/vault-uploads',
  path: '/vault-uploads',
  getParentRoute: () => AdminRoute,
} as any)
const AdminTermsRoute = AdminTermsRouteImport.update({
  id: '/terms',
  path: '/terms',
  getParentRoute: () => AdminRoute,
} as any)
const AdminStrategyRunsRoute = AdminStrategyRunsRouteImport.update({
  id: '/strategy-runs',
  path: '/strategy-runs',
  getParentRoute: () => AdminRoute,
} as any)
const AdminSettingsRoute = AdminSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AdminRoute,
} as any)
const AdminPredicateRunsRoute = AdminPredicateRunsRouteImport.update({
  id: '/predicate-runs',
  path: '/predicate-runs',
  getParentRoute: () => AdminRoute,
} as any)
const AdminMcpHealthRoute = AdminMcpHealthRouteImport.update({
  id: '/mcp-health',
  path: '/mcp-health',
  getParentRoute: () => AdminRoute,
} as any)
const AdminLoginRoute = AdminLoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => AdminRoute,
} as any)
const AdminExtractionRunsRoute = AdminExtractionRunsRouteImport.update({
  id: '/extraction-runs',
  path: '/extraction-runs',
  getParentRoute: () => AdminRoute,
} as any)
const AdminDossierRunsRoute = AdminDossierRunsRouteImport.update({
  id: '/dossier-runs',
  path: '/dossier-runs',
  getParentRoute: () => AdminRoute,
} as any)
const AdminDashboardRoute = AdminDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => AdminRoute,
} as any)
const AdminCompaniesRoute = AdminCompaniesRouteImport.update({
  id: '/companies',
  path: '/companies',
  getParentRoute: () => AdminRoute,
} as any)
const AdminClinicalReportRunsRoute = AdminClinicalReportRunsRouteImport.update({
  id: '/clinical-report-runs',
  path: '/clinical-report-runs',
  getParentRoute: () => AdminRoute,
} as any)
const AdminClinicalProtocolRunsRoute =
  AdminClinicalProtocolRunsRouteImport.update({
    id: '/clinical-protocol-runs',
    path: '/clinical-protocol-runs',
    getParentRoute: () => AdminRoute,
  } as any)
const AdminArchiveImportRunsRoute = AdminArchiveImportRunsRouteImport.update({
  id: '/archive-import-runs',
  path: '/archive-import-runs',
  getParentRoute: () => AdminRoute,
} as any)
const VaultFolderFolderRoute = VaultFolderFolderRouteImport.update({
  id: '/vault_/folder/$folder',
  path: '/vault/folder/$folder',
  getParentRoute: () => rootRouteImport,
} as any)
const VaultDocumentRefRoute = VaultDocumentRefRouteImport.update({
  id: '/vault_/document/$ref',
  path: '/vault/document/$ref',
  getParentRoute: () => rootRouteImport,
} as any)
const ProductAccountProductIdReviewRoute =
  ProductAccountProductIdReviewRouteImport.update({
    id: '/product-account_/$productId_/review',
    path: '/product-account/$productId/review',
    getParentRoute: () => rootRouteImport,
  } as any)
const ProductAccountProductIdEditRoute =
  ProductAccountProductIdEditRouteImport.update({
    id: '/product-account_/$productId_/edit',
    path: '/product-account/$productId/edit',
    getParentRoute: () => rootRouteImport,
  } as any)
const AdminCompaniesCustomerIdRoute =
  AdminCompaniesCustomerIdRouteImport.update({
    id: '/companies_/$customerId',
    path: '/companies/$customerId',
    getParentRoute: () => AdminRoute,
  } as any)
const VaultDocumentRefIndexRoute = VaultDocumentRefIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => VaultDocumentRefRoute,
} as any)
const VaultMarketSourceTypeProductIdRoute =
  VaultMarketSourceTypeProductIdRouteImport.update({
    id: '/vault_/market/$sourceType/$productId',
    path: '/vault/market/$sourceType/$productId',
    getParentRoute: () => rootRouteImport,
  } as any)
const VaultDocumentRefReviewRoute = VaultDocumentRefReviewRouteImport.update({
  id: '/review',
  path: '/review',
  getParentRoute: () => VaultDocumentRefRoute,
} as any)
const VaultDocumentRefEditRoute = VaultDocumentRefEditRouteImport.update({
  id: '/edit',
  path: '/edit',
  getParentRoute: () => VaultDocumentRefRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/admin': typeof AdminRouteWithChildren
  '/billing': typeof BillingRoute
  '/clinical-protocols': typeof ClinicalProtocolsRoute
  '/clinical-reports': typeof ClinicalReportsRoute
  '/customer-account': typeof CustomerAccountRoute
  '/dashboard': typeof DashboardRoute
  '/faq': typeof FaqRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/predicate-finder': typeof PredicateFinderRoute
  '/predicate-finder-result': typeof PredicateFinderResultRoute
  '/product-account': typeof ProductAccountRoute
  '/profile': typeof ProfileRoute
  '/regulatory-strategy': typeof RegulatoryStrategyRoute
  '/reset-password': typeof ResetPasswordRoute
  '/signup': typeof SignupRoute
  '/simulators': typeof SimulatorsRoute
  '/submission-dossier': typeof SubmissionDossierRoute
  '/support': typeof SupportRoute
  '/suspended': typeof SuspendedRoute
  '/team': typeof TeamRoute
  '/vault': typeof VaultRoute
  '/admin/archive-import-runs': typeof AdminArchiveImportRunsRoute
  '/admin/clinical-protocol-runs': typeof AdminClinicalProtocolRunsRoute
  '/admin/clinical-report-runs': typeof AdminClinicalReportRunsRoute
  '/admin/companies': typeof AdminCompaniesRoute
  '/admin/dashboard': typeof AdminDashboardRoute
  '/admin/dossier-runs': typeof AdminDossierRunsRoute
  '/admin/extraction-runs': typeof AdminExtractionRunsRoute
  '/admin/login': typeof AdminLoginRoute
  '/admin/mcp-health': typeof AdminMcpHealthRoute
  '/admin/predicate-runs': typeof AdminPredicateRunsRoute
  '/admin/settings': typeof AdminSettingsRoute
  '/admin/strategy-runs': typeof AdminStrategyRunsRoute
  '/admin/terms': typeof AdminTermsRoute
  '/admin/vault-uploads': typeof AdminVaultUploadsRoute
  '/clinical-protocols/$productId': typeof ClinicalProtocolsProductIdRoute
  '/clinical-reports/$productId': typeof ClinicalReportsProductIdRoute
  '/customer-account/new': typeof CustomerAccountNewRoute
  '/onboarding/terms': typeof OnboardingTermsRoute
  '/predicate-finder/$productId': typeof PredicateFinderProductIdRoute
  '/product-account/new': typeof ProductAccountNewRoute
  '/regulatory-strategy/$productId': typeof RegulatoryStrategyProductIdRoute
  '/simulators/clinical-protocol': typeof SimulatorsClinicalProtocolRoute
  '/simulators/dossier': typeof SimulatorsDossierRoute
  '/simulators/regulatory-strategy': typeof SimulatorsRegulatoryStrategyRoute
  '/submission-dossier/$productId': typeof SubmissionDossierProductIdRoute
  '/admin/companies/$customerId': typeof AdminCompaniesCustomerIdRoute
  '/product-account/$productId/edit': typeof ProductAccountProductIdEditRoute
  '/product-account/$productId/review': typeof ProductAccountProductIdReviewRoute
  '/vault/document/$ref': typeof VaultDocumentRefRouteWithChildren
  '/vault/folder/$folder': typeof VaultFolderFolderRoute
  '/vault/document/$ref/edit': typeof VaultDocumentRefEditRoute
  '/vault/document/$ref/review': typeof VaultDocumentRefReviewRoute
  '/vault/market/$sourceType/$productId': typeof VaultMarketSourceTypeProductIdRoute
  '/vault/document/$ref/': typeof VaultDocumentRefIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/admin': typeof AdminRouteWithChildren
  '/billing': typeof BillingRoute
  '/clinical-protocols': typeof ClinicalProtocolsRoute
  '/clinical-reports': typeof ClinicalReportsRoute
  '/customer-account': typeof CustomerAccountRoute
  '/dashboard': typeof DashboardRoute
  '/faq': typeof FaqRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/predicate-finder': typeof PredicateFinderRoute
  '/predicate-finder-result': typeof PredicateFinderResultRoute
  '/product-account': typeof ProductAccountRoute
  '/profile': typeof ProfileRoute
  '/regulatory-strategy': typeof RegulatoryStrategyRoute
  '/reset-password': typeof ResetPasswordRoute
  '/signup': typeof SignupRoute
  '/simulators': typeof SimulatorsRoute
  '/submission-dossier': typeof SubmissionDossierRoute
  '/support': typeof SupportRoute
  '/suspended': typeof SuspendedRoute
  '/team': typeof TeamRoute
  '/vault': typeof VaultRoute
  '/admin/archive-import-runs': typeof AdminArchiveImportRunsRoute
  '/admin/clinical-protocol-runs': typeof AdminClinicalProtocolRunsRoute
  '/admin/clinical-report-runs': typeof AdminClinicalReportRunsRoute
  '/admin/companies': typeof AdminCompaniesRoute
  '/admin/dashboard': typeof AdminDashboardRoute
  '/admin/dossier-runs': typeof AdminDossierRunsRoute
  '/admin/extraction-runs': typeof AdminExtractionRunsRoute
  '/admin/login': typeof AdminLoginRoute
  '/admin/mcp-health': typeof AdminMcpHealthRoute
  '/admin/predicate-runs': typeof AdminPredicateRunsRoute
  '/admin/settings': typeof AdminSettingsRoute
  '/admin/strategy-runs': typeof AdminStrategyRunsRoute
  '/admin/terms': typeof AdminTermsRoute
  '/admin/vault-uploads': typeof AdminVaultUploadsRoute
  '/clinical-protocols/$productId': typeof ClinicalProtocolsProductIdRoute
  '/clinical-reports/$productId': typeof ClinicalReportsProductIdRoute
  '/customer-account/new': typeof CustomerAccountNewRoute
  '/onboarding/terms': typeof OnboardingTermsRoute
  '/predicate-finder/$productId': typeof PredicateFinderProductIdRoute
  '/product-account/new': typeof ProductAccountNewRoute
  '/regulatory-strategy/$productId': typeof RegulatoryStrategyProductIdRoute
  '/simulators/clinical-protocol': typeof SimulatorsClinicalProtocolRoute
  '/simulators/dossier': typeof SimulatorsDossierRoute
  '/simulators/regulatory-strategy': typeof SimulatorsRegulatoryStrategyRoute
  '/submission-dossier/$productId': typeof SubmissionDossierProductIdRoute
  '/admin/companies/$customerId': typeof AdminCompaniesCustomerIdRoute
  '/product-account/$productId/edit': typeof ProductAccountProductIdEditRoute
  '/product-account/$productId/review': typeof ProductAccountProductIdReviewRoute
  '/vault/folder/$folder': typeof VaultFolderFolderRoute
  '/vault/document/$ref/edit': typeof VaultDocumentRefEditRoute
  '/vault/document/$ref/review': typeof VaultDocumentRefReviewRoute
  '/vault/market/$sourceType/$productId': typeof VaultMarketSourceTypeProductIdRoute
  '/vault/document/$ref': typeof VaultDocumentRefIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/admin': typeof AdminRouteWithChildren
  '/billing': typeof BillingRoute
  '/clinical-protocols': typeof ClinicalProtocolsRoute
  '/clinical-reports': typeof ClinicalReportsRoute
  '/customer-account': typeof CustomerAccountRoute
  '/dashboard': typeof DashboardRoute
  '/faq': typeof FaqRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/predicate-finder': typeof PredicateFinderRoute
  '/predicate-finder-result': typeof PredicateFinderResultRoute
  '/product-account': typeof ProductAccountRoute
  '/profile': typeof ProfileRoute
  '/regulatory-strategy': typeof RegulatoryStrategyRoute
  '/reset-password': typeof ResetPasswordRoute
  '/signup': typeof SignupRoute
  '/simulators': typeof SimulatorsRoute
  '/submission-dossier': typeof SubmissionDossierRoute
  '/support': typeof SupportRoute
  '/suspended': typeof SuspendedRoute
  '/team': typeof TeamRoute
  '/vault': typeof VaultRoute
  '/admin/archive-import-runs': typeof AdminArchiveImportRunsRoute
  '/admin/clinical-protocol-runs': typeof AdminClinicalProtocolRunsRoute
  '/admin/clinical-report-runs': typeof AdminClinicalReportRunsRoute
  '/admin/companies': typeof AdminCompaniesRoute
  '/admin/dashboard': typeof AdminDashboardRoute
  '/admin/dossier-runs': typeof AdminDossierRunsRoute
  '/admin/extraction-runs': typeof AdminExtractionRunsRoute
  '/admin/login': typeof AdminLoginRoute
  '/admin/mcp-health': typeof AdminMcpHealthRoute
  '/admin/predicate-runs': typeof AdminPredicateRunsRoute
  '/admin/settings': typeof AdminSettingsRoute
  '/admin/strategy-runs': typeof AdminStrategyRunsRoute
  '/admin/terms': typeof AdminTermsRoute
  '/admin/vault-uploads': typeof AdminVaultUploadsRoute
  '/clinical-protocols_/$productId': typeof ClinicalProtocolsProductIdRoute
  '/clinical-reports_/$productId': typeof ClinicalReportsProductIdRoute
  '/customer-account_/new': typeof CustomerAccountNewRoute
  '/onboarding_/terms': typeof OnboardingTermsRoute
  '/predicate-finder_/$productId': typeof PredicateFinderProductIdRoute
  '/product-account_/new': typeof ProductAccountNewRoute
  '/regulatory-strategy_/$productId': typeof RegulatoryStrategyProductIdRoute
  '/simulators_/clinical-protocol': typeof SimulatorsClinicalProtocolRoute
  '/simulators_/dossier': typeof SimulatorsDossierRoute
  '/simulators_/regulatory-strategy': typeof SimulatorsRegulatoryStrategyRoute
  '/submission-dossier_/$productId': typeof SubmissionDossierProductIdRoute
  '/admin/companies_/$customerId': typeof AdminCompaniesCustomerIdRoute
  '/product-account_/$productId_/edit': typeof ProductAccountProductIdEditRoute
  '/product-account_/$productId_/review': typeof ProductAccountProductIdReviewRoute
  '/vault_/document/$ref': typeof VaultDocumentRefRouteWithChildren
  '/vault_/folder/$folder': typeof VaultFolderFolderRoute
  '/vault_/document/$ref/edit': typeof VaultDocumentRefEditRoute
  '/vault_/document/$ref/review': typeof VaultDocumentRefReviewRoute
  '/vault_/market/$sourceType/$productId': typeof VaultMarketSourceTypeProductIdRoute
  '/vault_/document/$ref/': typeof VaultDocumentRefIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/admin'
    | '/billing'
    | '/clinical-protocols'
    | '/clinical-reports'
    | '/customer-account'
    | '/dashboard'
    | '/faq'
    | '/forgot-password'
    | '/login'
    | '/predicate-finder'
    | '/predicate-finder-result'
    | '/product-account'
    | '/profile'
    | '/regulatory-strategy'
    | '/reset-password'
    | '/signup'
    | '/simulators'
    | '/submission-dossier'
    | '/support'
    | '/suspended'
    | '/team'
    | '/vault'
    | '/admin/archive-import-runs'
    | '/admin/clinical-protocol-runs'
    | '/admin/clinical-report-runs'
    | '/admin/companies'
    | '/admin/dashboard'
    | '/admin/dossier-runs'
    | '/admin/extraction-runs'
    | '/admin/login'
    | '/admin/mcp-health'
    | '/admin/predicate-runs'
    | '/admin/settings'
    | '/admin/strategy-runs'
    | '/admin/terms'
    | '/admin/vault-uploads'
    | '/clinical-protocols/$productId'
    | '/clinical-reports/$productId'
    | '/customer-account/new'
    | '/onboarding/terms'
    | '/predicate-finder/$productId'
    | '/product-account/new'
    | '/regulatory-strategy/$productId'
    | '/simulators/clinical-protocol'
    | '/simulators/dossier'
    | '/simulators/regulatory-strategy'
    | '/submission-dossier/$productId'
    | '/admin/companies/$customerId'
    | '/product-account/$productId/edit'
    | '/product-account/$productId/review'
    | '/vault/document/$ref'
    | '/vault/folder/$folder'
    | '/vault/document/$ref/edit'
    | '/vault/document/$ref/review'
    | '/vault/market/$sourceType/$productId'
    | '/vault/document/$ref/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/admin'
    | '/billing'
    | '/clinical-protocols'
    | '/clinical-reports'
    | '/customer-account'
    | '/dashboard'
    | '/faq'
    | '/forgot-password'
    | '/login'
    | '/predicate-finder'
    | '/predicate-finder-result'
    | '/product-account'
    | '/profile'
    | '/regulatory-strategy'
    | '/reset-password'
    | '/signup'
    | '/simulators'
    | '/submission-dossier'
    | '/support'
    | '/suspended'
    | '/team'
    | '/vault'
    | '/admin/archive-import-runs'
    | '/admin/clinical-protocol-runs'
    | '/admin/clinical-report-runs'
    | '/admin/companies'
    | '/admin/dashboard'
    | '/admin/dossier-runs'
    | '/admin/extraction-runs'
    | '/admin/login'
    | '/admin/mcp-health'
    | '/admin/predicate-runs'
    | '/admin/settings'
    | '/admin/strategy-runs'
    | '/admin/terms'
    | '/admin/vault-uploads'
    | '/clinical-protocols/$productId'
    | '/clinical-reports/$productId'
    | '/customer-account/new'
    | '/onboarding/terms'
    | '/predicate-finder/$productId'
    | '/product-account/new'
    | '/regulatory-strategy/$productId'
    | '/simulators/clinical-protocol'
    | '/simulators/dossier'
    | '/simulators/regulatory-strategy'
    | '/submission-dossier/$productId'
    | '/admin/companies/$customerId'
    | '/product-account/$productId/edit'
    | '/product-account/$productId/review'
    | '/vault/folder/$folder'
    | '/vault/document/$ref/edit'
    | '/vault/document/$ref/review'
    | '/vault/market/$sourceType/$productId'
    | '/vault/document/$ref'
  id:
    | '__root__'
    | '/'
    | '/admin'
    | '/billing'
    | '/clinical-protocols'
    | '/clinical-reports'
    | '/customer-account'
    | '/dashboard'
    | '/faq'
    | '/forgot-password'
    | '/login'
    | '/predicate-finder'
    | '/predicate-finder-result'
    | '/product-account'
    | '/profile'
    | '/regulatory-strategy'
    | '/reset-password'
    | '/signup'
    | '/simulators'
    | '/submission-dossier'
    | '/support'
    | '/suspended'
    | '/team'
    | '/vault'
    | '/admin/archive-import-runs'
    | '/admin/clinical-protocol-runs'
    | '/admin/clinical-report-runs'
    | '/admin/companies'
    | '/admin/dashboard'
    | '/admin/dossier-runs'
    | '/admin/extraction-runs'
    | '/admin/login'
    | '/admin/mcp-health'
    | '/admin/predicate-runs'
    | '/admin/settings'
    | '/admin/strategy-runs'
    | '/admin/terms'
    | '/admin/vault-uploads'
    | '/clinical-protocols_/$productId'
    | '/clinical-reports_/$productId'
    | '/customer-account_/new'
    | '/onboarding_/terms'
    | '/predicate-finder_/$productId'
    | '/product-account_/new'
    | '/regulatory-strategy_/$productId'
    | '/simulators_/clinical-protocol'
    | '/simulators_/dossier'
    | '/simulators_/regulatory-strategy'
    | '/submission-dossier_/$productId'
    | '/admin/companies_/$customerId'
    | '/product-account_/$productId_/edit'
    | '/product-account_/$productId_/review'
    | '/vault_/document/$ref'
    | '/vault_/folder/$folder'
    | '/vault_/document/$ref/edit'
    | '/vault_/document/$ref/review'
    | '/vault_/market/$sourceType/$productId'
    | '/vault_/document/$ref/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AdminRoute: typeof AdminRouteWithChildren
  BillingRoute: typeof BillingRoute
  ClinicalProtocolsRoute: typeof ClinicalProtocolsRoute
  ClinicalReportsRoute: typeof ClinicalReportsRoute
  CustomerAccountRoute: typeof CustomerAccountRoute
  DashboardRoute: typeof DashboardRoute
  FaqRoute: typeof FaqRoute
  ForgotPasswordRoute: typeof ForgotPasswordRoute
  LoginRoute: typeof LoginRoute
  PredicateFinderRoute: typeof PredicateFinderRoute
  PredicateFinderResultRoute: typeof PredicateFinderResultRoute
  ProductAccountRoute: typeof ProductAccountRoute
  ProfileRoute: typeof ProfileRoute
  RegulatoryStrategyRoute: typeof RegulatoryStrategyRoute
  ResetPasswordRoute: typeof ResetPasswordRoute
  SignupRoute: typeof SignupRoute
  SimulatorsRoute: typeof SimulatorsRoute
  SubmissionDossierRoute: typeof SubmissionDossierRoute
  SupportRoute: typeof SupportRoute
  SuspendedRoute: typeof SuspendedRoute
  TeamRoute: typeof TeamRoute
  VaultRoute: typeof VaultRoute
  ClinicalProtocolsProductIdRoute: typeof ClinicalProtocolsProductIdRoute
  ClinicalReportsProductIdRoute: typeof ClinicalReportsProductIdRoute
  CustomerAccountNewRoute: typeof CustomerAccountNewRoute
  OnboardingTermsRoute: typeof OnboardingTermsRoute
  PredicateFinderProductIdRoute: typeof PredicateFinderProductIdRoute
  ProductAccountNewRoute: typeof ProductAccountNewRoute
  RegulatoryStrategyProductIdRoute: typeof RegulatoryStrategyProductIdRoute
  SimulatorsClinicalProtocolRoute: typeof SimulatorsClinicalProtocolRoute
  SimulatorsDossierRoute: typeof SimulatorsDossierRoute
  SimulatorsRegulatoryStrategyRoute: typeof SimulatorsRegulatoryStrategyRoute
  SubmissionDossierProductIdRoute: typeof SubmissionDossierProductIdRoute
  ProductAccountProductIdEditRoute: typeof ProductAccountProductIdEditRoute
  ProductAccountProductIdReviewRoute: typeof ProductAccountProductIdReviewRoute
  VaultDocumentRefRoute: typeof VaultDocumentRefRouteWithChildren
  VaultFolderFolderRoute: typeof VaultFolderFolderRoute
  VaultMarketSourceTypeProductIdRoute: typeof VaultMarketSourceTypeProductIdRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/vault': {
      id: '/vault'
      path: '/vault'
      fullPath: '/vault'
      preLoaderRoute: typeof VaultRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/team': {
      id: '/team'
      path: '/team'
      fullPath: '/team'
      preLoaderRoute: typeof TeamRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/suspended': {
      id: '/suspended'
      path: '/suspended'
      fullPath: '/suspended'
      preLoaderRoute: typeof SuspendedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/support': {
      id: '/support'
      path: '/support'
      fullPath: '/support'
      preLoaderRoute: typeof SupportRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/submission-dossier': {
      id: '/submission-dossier'
      path: '/submission-dossier'
      fullPath: '/submission-dossier'
      preLoaderRoute: typeof SubmissionDossierRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/simulators': {
      id: '/simulators'
      path: '/simulators'
      fullPath: '/simulators'
      preLoaderRoute: typeof SimulatorsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/signup': {
      id: '/signup'
      path: '/signup'
      fullPath: '/signup'
      preLoaderRoute: typeof SignupRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reset-password': {
      id: '/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof ResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/regulatory-strategy': {
      id: '/regulatory-strategy'
      path: '/regulatory-strategy'
      fullPath: '/regulatory-strategy'
      preLoaderRoute: typeof RegulatoryStrategyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/profile': {
      id: '/profile'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof ProfileRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/product-account': {
      id: '/product-account'
      path: '/product-account'
      fullPath: '/product-account'
      preLoaderRoute: typeof ProductAccountRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/predicate-finder-result': {
      id: '/predicate-finder-result'
      path: '/predicate-finder-result'
      fullPath: '/predicate-finder-result'
      preLoaderRoute: typeof PredicateFinderResultRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/predicate-finder': {
      id: '/predicate-finder'
      path: '/predicate-finder'
      fullPath: '/predicate-finder'
      preLoaderRoute: typeof PredicateFinderRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forgot-password': {
      id: '/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof ForgotPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/faq': {
      id: '/faq'
      path: '/faq'
      fullPath: '/faq'
      preLoaderRoute: typeof FaqRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard': {
      id: '/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof DashboardRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/customer-account': {
      id: '/customer-account'
      path: '/customer-account'
      fullPath: '/customer-account'
      preLoaderRoute: typeof CustomerAccountRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/clinical-reports': {
      id: '/clinical-reports'
      path: '/clinical-reports'
      fullPath: '/clinical-reports'
      preLoaderRoute: typeof ClinicalReportsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/clinical-protocols': {
      id: '/clinical-protocols'
      path: '/clinical-protocols'
      fullPath: '/clinical-protocols'
      preLoaderRoute: typeof ClinicalProtocolsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/billing': {
      id: '/billing'
      path: '/billing'
      fullPath: '/billing'
      preLoaderRoute: typeof BillingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin': {
      id: '/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AdminRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/submission-dossier_/$productId': {
      id: '/submission-dossier_/$productId'
      path: '/submission-dossier/$productId'
      fullPath: '/submission-dossier/$productId'
      preLoaderRoute: typeof SubmissionDossierProductIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/simulators_/regulatory-strategy': {
      id: '/simulators_/regulatory-strategy'
      path: '/simulators/regulatory-strategy'
      fullPath: '/simulators/regulatory-strategy'
      preLoaderRoute: typeof SimulatorsRegulatoryStrategyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/simulators_/dossier': {
      id: '/simulators_/dossier'
      path: '/simulators/dossier'
      fullPath: '/simulators/dossier'
      preLoaderRoute: typeof SimulatorsDossierRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/simulators_/clinical-protocol': {
      id: '/simulators_/clinical-protocol'
      path: '/simulators/clinical-protocol'
      fullPath: '/simulators/clinical-protocol'
      preLoaderRoute: typeof SimulatorsClinicalProtocolRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/regulatory-strategy_/$productId': {
      id: '/regulatory-strategy_/$productId'
      path: '/regulatory-strategy/$productId'
      fullPath: '/regulatory-strategy/$productId'
      preLoaderRoute: typeof RegulatoryStrategyProductIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/product-account_/new': {
      id: '/product-account_/new'
      path: '/product-account/new'
      fullPath: '/product-account/new'
      preLoaderRoute: typeof ProductAccountNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/predicate-finder_/$productId': {
      id: '/predicate-finder_/$productId'
      path: '/predicate-finder/$productId'
      fullPath: '/predicate-finder/$productId'
      preLoaderRoute: typeof PredicateFinderProductIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/onboarding_/terms': {
      id: '/onboarding_/terms'
      path: '/onboarding/terms'
      fullPath: '/onboarding/terms'
      preLoaderRoute: typeof OnboardingTermsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/customer-account_/new': {
      id: '/customer-account_/new'
      path: '/customer-account/new'
      fullPath: '/customer-account/new'
      preLoaderRoute: typeof CustomerAccountNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/clinical-reports_/$productId': {
      id: '/clinical-reports_/$productId'
      path: '/clinical-reports/$productId'
      fullPath: '/clinical-reports/$productId'
      preLoaderRoute: typeof ClinicalReportsProductIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/clinical-protocols_/$productId': {
      id: '/clinical-protocols_/$productId'
      path: '/clinical-protocols/$productId'
      fullPath: '/clinical-protocols/$productId'
      preLoaderRoute: typeof ClinicalProtocolsProductIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/vault-uploads': {
      id: '/admin/vault-uploads'
      path: '/vault-uploads'
      fullPath: '/admin/vault-uploads'
      preLoaderRoute: typeof AdminVaultUploadsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/terms': {
      id: '/admin/terms'
      path: '/terms'
      fullPath: '/admin/terms'
      preLoaderRoute: typeof AdminTermsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/strategy-runs': {
      id: '/admin/strategy-runs'
      path: '/strategy-runs'
      fullPath: '/admin/strategy-runs'
      preLoaderRoute: typeof AdminStrategyRunsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/settings': {
      id: '/admin/settings'
      path: '/settings'
      fullPath: '/admin/settings'
      preLoaderRoute: typeof AdminSettingsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/predicate-runs': {
      id: '/admin/predicate-runs'
      path: '/predicate-runs'
      fullPath: '/admin/predicate-runs'
      preLoaderRoute: typeof AdminPredicateRunsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/mcp-health': {
      id: '/admin/mcp-health'
      path: '/mcp-health'
      fullPath: '/admin/mcp-health'
      preLoaderRoute: typeof AdminMcpHealthRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/login': {
      id: '/admin/login'
      path: '/login'
      fullPath: '/admin/login'
      preLoaderRoute: typeof AdminLoginRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/extraction-runs': {
      id: '/admin/extraction-runs'
      path: '/extraction-runs'
      fullPath: '/admin/extraction-runs'
      preLoaderRoute: typeof AdminExtractionRunsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/dossier-runs': {
      id: '/admin/dossier-runs'
      path: '/dossier-runs'
      fullPath: '/admin/dossier-runs'
      preLoaderRoute: typeof AdminDossierRunsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/dashboard': {
      id: '/admin/dashboard'
      path: '/dashboard'
      fullPath: '/admin/dashboard'
      preLoaderRoute: typeof AdminDashboardRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/companies': {
      id: '/admin/companies'
      path: '/companies'
      fullPath: '/admin/companies'
      preLoaderRoute: typeof AdminCompaniesRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/clinical-report-runs': {
      id: '/admin/clinical-report-runs'
      path: '/clinical-report-runs'
      fullPath: '/admin/clinical-report-runs'
      preLoaderRoute: typeof AdminClinicalReportRunsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/clinical-protocol-runs': {
      id: '/admin/clinical-protocol-runs'
      path: '/clinical-protocol-runs'
      fullPath: '/admin/clinical-protocol-runs'
      preLoaderRoute: typeof AdminClinicalProtocolRunsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/archive-import-runs': {
      id: '/admin/archive-import-runs'
      path: '/archive-import-runs'
      fullPath: '/admin/archive-import-runs'
      preLoaderRoute: typeof AdminArchiveImportRunsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/vault_/folder/$folder': {
      id: '/vault_/folder/$folder'
      path: '/vault/folder/$folder'
      fullPath: '/vault/folder/$folder'
      preLoaderRoute: typeof VaultFolderFolderRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/vault_/document/$ref': {
      id: '/vault_/document/$ref'
      path: '/vault/document/$ref'
      fullPath: '/vault/document/$ref'
      preLoaderRoute: typeof VaultDocumentRefRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/product-account_/$productId_/review': {
      id: '/product-account_/$productId_/review'
      path: '/product-account/$productId/review'
      fullPath: '/product-account/$productId/review'
      preLoaderRoute: typeof ProductAccountProductIdReviewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/product-account_/$productId_/edit': {
      id: '/product-account_/$productId_/edit'
      path: '/product-account/$productId/edit'
      fullPath: '/product-account/$productId/edit'
      preLoaderRoute: typeof ProductAccountProductIdEditRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/companies_/$customerId': {
      id: '/admin/companies_/$customerId'
      path: '/companies/$customerId'
      fullPath: '/admin/companies/$customerId'
      preLoaderRoute: typeof AdminCompaniesCustomerIdRouteImport
      parentRoute: typeof AdminRoute
    }
    '/vault_/document/$ref/': {
      id: '/vault_/document/$ref/'
      path: '/'
      fullPath: '/vault/document/$ref/'
      preLoaderRoute: typeof VaultDocumentRefIndexRouteImport
      parentRoute: typeof VaultDocumentRefRoute
    }
    '/vault_/market/$sourceType/$productId': {
      id: '/vault_/market/$sourceType/$productId'
      path: '/vault/market/$sourceType/$productId'
      fullPath: '/vault/market/$sourceType/$productId'
      preLoaderRoute: typeof VaultMarketSourceTypeProductIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/vault_/document/$ref/review': {
      id: '/vault_/document/$ref/review'
      path: '/review'
      fullPath: '/vault/document/$ref/review'
      preLoaderRoute: typeof VaultDocumentRefReviewRouteImport
      parentRoute: typeof VaultDocumentRefRoute
    }
    '/vault_/document/$ref/edit': {
      id: '/vault_/document/$ref/edit'
      path: '/edit'
      fullPath: '/vault/document/$ref/edit'
      preLoaderRoute: typeof VaultDocumentRefEditRouteImport
      parentRoute: typeof VaultDocumentRefRoute
    }
  }
}

interface AdminRouteChildren {
  AdminArchiveImportRunsRoute: typeof AdminArchiveImportRunsRoute
  AdminClinicalProtocolRunsRoute: typeof AdminClinicalProtocolRunsRoute
  AdminClinicalReportRunsRoute: typeof AdminClinicalReportRunsRoute
  AdminCompaniesRoute: typeof AdminCompaniesRoute
  AdminDashboardRoute: typeof AdminDashboardRoute
  AdminDossierRunsRoute: typeof AdminDossierRunsRoute
  AdminExtractionRunsRoute: typeof AdminExtractionRunsRoute
  AdminLoginRoute: typeof AdminLoginRoute
  AdminMcpHealthRoute: typeof AdminMcpHealthRoute
  AdminPredicateRunsRoute: typeof AdminPredicateRunsRoute
  AdminSettingsRoute: typeof AdminSettingsRoute
  AdminStrategyRunsRoute: typeof AdminStrategyRunsRoute
  AdminTermsRoute: typeof AdminTermsRoute
  AdminVaultUploadsRoute: typeof AdminVaultUploadsRoute
  AdminCompaniesCustomerIdRoute: typeof AdminCompaniesCustomerIdRoute
}

const AdminRouteChildren: AdminRouteChildren = {
  AdminArchiveImportRunsRoute: AdminArchiveImportRunsRoute,
  AdminClinicalProtocolRunsRoute: AdminClinicalProtocolRunsRoute,
  AdminClinicalReportRunsRoute: AdminClinicalReportRunsRoute,
  AdminCompaniesRoute: AdminCompaniesRoute,
  AdminDashboardRoute: AdminDashboardRoute,
  AdminDossierRunsRoute: AdminDossierRunsRoute,
  AdminExtractionRunsRoute: AdminExtractionRunsRoute,
  AdminLoginRoute: AdminLoginRoute,
  AdminMcpHealthRoute: AdminMcpHealthRoute,
  AdminPredicateRunsRoute: AdminPredicateRunsRoute,
  AdminSettingsRoute: AdminSettingsRoute,
  AdminStrategyRunsRoute: AdminStrategyRunsRoute,
  AdminTermsRoute: AdminTermsRoute,
  AdminVaultUploadsRoute: AdminVaultUploadsRoute,
  AdminCompaniesCustomerIdRoute: AdminCompaniesCustomerIdRoute,
}

const AdminRouteWithChildren = AdminRoute._addFileChildren(AdminRouteChildren)

interface VaultDocumentRefRouteChildren {
  VaultDocumentRefEditRoute: typeof VaultDocumentRefEditRoute
  VaultDocumentRefReviewRoute: typeof VaultDocumentRefReviewRoute
  VaultDocumentRefIndexRoute: typeof VaultDocumentRefIndexRoute
}

const VaultDocumentRefRouteChildren: VaultDocumentRefRouteChildren = {
  VaultDocumentRefEditRoute: VaultDocumentRefEditRoute,
  VaultDocumentRefReviewRoute: VaultDocumentRefReviewRoute,
  VaultDocumentRefIndexRoute: VaultDocumentRefIndexRoute,
}

const VaultDocumentRefRouteWithChildren =
  VaultDocumentRefRoute._addFileChildren(VaultDocumentRefRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AdminRoute: AdminRouteWithChildren,
  BillingRoute: BillingRoute,
  ClinicalProtocolsRoute: ClinicalProtocolsRoute,
  ClinicalReportsRoute: ClinicalReportsRoute,
  CustomerAccountRoute: CustomerAccountRoute,
  DashboardRoute: DashboardRoute,
  FaqRoute: FaqRoute,
  ForgotPasswordRoute: ForgotPasswordRoute,
  LoginRoute: LoginRoute,
  PredicateFinderRoute: PredicateFinderRoute,
  PredicateFinderResultRoute: PredicateFinderResultRoute,
  ProductAccountRoute: ProductAccountRoute,
  ProfileRoute: ProfileRoute,
  RegulatoryStrategyRoute: RegulatoryStrategyRoute,
  ResetPasswordRoute: ResetPasswordRoute,
  SignupRoute: SignupRoute,
  SimulatorsRoute: SimulatorsRoute,
  SubmissionDossierRoute: SubmissionDossierRoute,
  SupportRoute: SupportRoute,
  SuspendedRoute: SuspendedRoute,
  TeamRoute: TeamRoute,
  VaultRoute: VaultRoute,
  ClinicalProtocolsProductIdRoute: ClinicalProtocolsProductIdRoute,
  ClinicalReportsProductIdRoute: ClinicalReportsProductIdRoute,
  CustomerAccountNewRoute: CustomerAccountNewRoute,
  OnboardingTermsRoute: OnboardingTermsRoute,
  PredicateFinderProductIdRoute: PredicateFinderProductIdRoute,
  ProductAccountNewRoute: ProductAccountNewRoute,
  RegulatoryStrategyProductIdRoute: RegulatoryStrategyProductIdRoute,
  SimulatorsClinicalProtocolRoute: SimulatorsClinicalProtocolRoute,
  SimulatorsDossierRoute: SimulatorsDossierRoute,
  SimulatorsRegulatoryStrategyRoute: SimulatorsRegulatoryStrategyRoute,
  SubmissionDossierProductIdRoute: SubmissionDossierProductIdRoute,
  ProductAccountProductIdEditRoute: ProductAccountProductIdEditRoute,
  ProductAccountProductIdReviewRoute: ProductAccountProductIdReviewRoute,
  VaultDocumentRefRoute: VaultDocumentRefRouteWithChildren,
  VaultFolderFolderRoute: VaultFolderFolderRoute,
  VaultMarketSourceTypeProductIdRoute: VaultMarketSourceTypeProductIdRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
